import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function useSettings() {
  return useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get("/settings/public")).data,
    staleTime: 300000,
  });
}

export function useContent(key) {
  return useQuery({
    queryKey: ["content", key],
    queryFn: async () => (await api.get(`/content/${key}`)).data,
    staleTime: 300000,
  });
}

export function useProducts(params = {}) {
  const qs = new URLSearchParams(params).toString();
  return useQuery({
    queryKey: ["products", params],
    queryFn: async () => (await api.get(`/products?${qs}`)).data,
  });
}

export function usePage(key) {
  return useQuery({
    queryKey: ["page", key],
    queryFn: async () => (await api.get(`/page/${key}`)).data,
    staleTime: 60000,
  });
}
